import PaginationContainer from '@af-common/Common/Pagination/_containers/PaginationContainer';
import ModalContainer from '@af-common/Common/_containers/ModalContainer';
import * as React from 'react';
import Dropzone, { DropzoneRef } from 'react-dropzone';
import LibraryBrowserItemContainer from '../_containers/LibraryBrowserItemContainer';
import TextInput from '@af-common/Common/_components/TextInput';
import { Trans } from 'react-i18next';
import { Grid, Skeleton, Card, Button } from '@mui/material';
import Loader from '@af-common/Common/_components/Loader';
import { ModuleTypes } from '../../Module/_config/ModuleInfo';
import ItemList from '@af-common/Common/Pagination/ItemList';

export type Props = {
	opened?: boolean
	element?: JSX.Element
	onClose?: Function
	onOpen?: Function
	onSelect?: Function
	onUpload?: Function
	loading?: boolean
	moduleType?: ModuleTypes,
	moduleUIType?: ModuleTypes
}

type State = {
	search: string
	isDragActive: boolean
}

const T = ({ children, ...otherProps }: any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class LibraryBrowser extends React.Component<Props, State> {
	private dropzoneRef: React.RefObject<DropzoneRef>;

	state = {
		search: '',
		isDragActive: false,
	} as State

	constructor(props: Props, state: State) {
		super(props);
		this.dropzoneRef = React.createRef();
	}

	componentDidMount() {
		if (this.props.moduleUIType == ModuleTypes.ImageUpload) {
			this.openDropzone();
		}
	}

	private onSearch = (search: string) => {
		this.setState({ search: search });
	}

	private onDragEnter = () => this.setState({ isDragActive: true });
	private onDragLeave = () => this.setState({ isDragActive: false });

	private onUpload = (files: File[]) => {
		this.setState({ isDragActive: false });
		let file: File;
		while (file = files.splice(0, 1)[0]) {
			let fd = new FormData();
			fd.append("file", file);
			this.props.onUpload(fd);
		}
	}

	private openDropzone = () => {
		if (!this.dropzoneRef.current) return;
		this.dropzoneRef.current.open();
	}

	render = () => {
		return <ModalContainer darken opened={this.props.opened} persist element={this.props.element} animate onOpen={this.props.onOpen} onClose={this.props.onClose} content={<>
			<Dropzone ref={this.dropzoneRef} noClick multiple accept={{ 'image/*': ['.png', '.gif', '.jpeg', '.jpg'] }} onDrop={acceptedFiles => this.onUpload(acceptedFiles)} onDragEnter={this.onDragEnter} onDragLeave={this.onDragLeave}>
				{({ getRootProps, getInputProps }) => (
					<div className={"library-browser" + (this.props.loading ? " library-browser--loading" : "")} {...getRootProps()}>
						<input {...getInputProps({ disabled: false })} />
						<Card elevation={24}>
							<Grid container className="library-browser-header">
								<Grid item xs={12}>
									<h3><T>Image Library</T></h3>
									<TextInput label={<T>Search</T>} value={this.state.search} onChange={(value) => this.onSearch(value)} />
								</Grid>
							</Grid>
							<div className="library-browser-body">
								<ItemList
									dataType="images"
									item={(item) => <LibraryBrowserItemContainer item={item} onSelect={this.props.onSelect} onClose={this.props.onClose} />}
									limit={18}
									searchQuery={this.state.search}
									controlled
									render={(items, links, loading) =>
										<Grid container className="pagination-container">
											<Grid item xs={12} className="pagination-container">
												{loading ?
													<Grid container spacing={2}>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
														<Grid item xs={4} sm={4} lg={3}><Skeleton variant="rectangular" width={"100%"} height={184} /></Grid>
													</Grid> :
													(items ? <>
														<Grid container spacing={2}>
															{items}
														</Grid> {links} </> :
														<span className="pagination-noitems"><T>No Results</T></span>
													)}
											</Grid>
										</Grid>
									}
								/>
							</div>
							<div className="library-browser-footer">
								<Button color="secondary" className="secondary-primary" onClick={this.openDropzone}><T>Upload</T></Button>
								<Button color="secondary" className="modal-close"><T>Cancel</T></Button>
							</div>
						</Card>
						{this.state.isDragActive &&
							<div className="dropzone-active">
								<div className="dropzone-text"><T>Drop your files here</T></div>
							</div>
						}
					</div>
				)}
			</Dropzone>
			{this.props.loading && <Loader noModal />}
		</>} />
	}
}